import { tokenPaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  // AI Token is tenant-implicit (one new-api user per organization): no id in the URL.
  { scope: 'External.Token', category: 'ai', route: () => tokenPaths.base },
] as const;
